export const variableNameRegex = new RegExp(/^[a-z\d]+(?:_[a-z\d]+)*$/);
export const emailRegex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/);
